import { render, staticRenderFns } from "./CourseofflineItemList.vue?vue&type=template&id=71b51fbe&scoped=true&"
import script from "./CourseofflineItemList.vue?vue&type=script&lang=js&"
export * from "./CourseofflineItemList.vue?vue&type=script&lang=js&"
import style0 from "./CourseofflineItemList.vue?vue&type=style&index=0&id=71b51fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b51fbe",
  null
  
)

export default component.exports